import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14272d29"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "frisbuy-fashion-list-item__description"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Подробнее", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PositionBlockWrapper = _resolveComponent("PositionBlockWrapper")!

  return (_openBlock(), _createElementBlock("li", {
    class: "frisbuy-fashion-list-item",
    onClick: _cache[1] || (_cache[1] = () => _ctx.clickPostHandler())
  }, [
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    (
        _ctx.previewImagePositionStyles &&
        Object.keys(_ctx.previewImagePositionStyles).length > 0
      )
      ? (_openBlock(), _createBlock(_component_PositionBlockWrapper, {
          key: 1,
          x: _ctx.previewImagePositionStyles.x,
          y: _ctx.previewImagePositionStyles.y,
          scale: _ctx.previewImagePositionStyles.scale / 100
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.postPreviewImage,
              alt: ""
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["x", "y", "scale"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "frisbuy-fashion-list-item__image",
          ref: "photo",
          style: _normalizeStyle({
        'background-image': `url(${_ctx.postPreviewImage}), url(${_ctx.postPreviewImage})`,
        'background-repeat': 'no-repeat',
      })
        }, [
          _createElementVNode("img", {
            ref: "image",
            src: _ctx.postPreviewImage,
            onError: _cache[0] || (_cache[0] = (e) => _ctx.errorImageHandler(e))
          }, null, 40, _hoisted_3)
        ], 4)),
    _hoisted_4
  ]))
}